import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from "@angular/core";
import * as dayjs from "dayjs";
import { NgxSpinnerService } from "ngx-spinner";
import { fromEvent, Subscription } from "rxjs";
import { throttleTime } from "rxjs/operators";
import { CampanaService } from "../campana.service";

interface DayUnits {
  text: string;
  mants: {
    Color: string;
    NoControl: string;
    Atrasado: boolean;
    Realizado: boolean;
  }[];
}

@Component({
  selector: "app-campana-calendar",
  templateUrl: "./calendar.component.html",
  styleUrls: ["./calendar.component.css"],
})
export class CampanaCalendarComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild("rightBtn") rightBtn!: ElementRef;
  @ViewChild("leftBtn") leftBtn!: ElementRef;
  private clickPlus!: Subscription;
  private clickMinus!: Subscription;
  daysMonth: DayUnits[] = [];
  meses = [
    "enero",
    "febrero",
    "marzo",
    "abril",
    "mayo",
    "junio",
    "julio",
    "agosto",
    "septiembre",
    "octubre",
    "noviembre",
    "diciembre",
  ];
  nombreMes = "";
  currentMonth: Date;
  campaings: any[] = [];
  constructor(
    public service: CampanaService,
    public spinner: NgxSpinnerService
  ) {}

  ngOnInit(): void {
    this.currentMonth = dayjs().startOf("month").toDate();
    this.drawCalendar();
  }
  ngAfterViewInit(): void {
    this.clickPlus = fromEvent(this.leftBtn.nativeElement, "click")
      .pipe(throttleTime(1000))
      .subscribe(() => {
        this.changeMonth(-1);
      });
    this.clickMinus = fromEvent(this.rightBtn.nativeElement, "click")
      .pipe(throttleTime(1000))
      .subscribe(() => {
        this.changeMonth(1);
      });
  }

  ngOnDestroy(): void {
    this.clickMinus?.unsubscribe();
    this.clickPlus?.unsubscribe();
  }

  changeMonth(change: number) {
    this.currentMonth = dayjs(this.currentMonth).add(change, "month").toDate();
    this.drawCalendar();
    // tu lógica aquí
  }
  drawCalendar() {
    this.spinner.show();
    this.daysMonth = [];
    this.nombreMes = this.meses[this.currentMonth.getMonth()];
    const monthStart = dayjs(this.currentMonth).startOf("month").day();
    const monthEnd2 = dayjs(this.currentMonth).endOf("month").date();

    this.service
      .get(this.currentMonth.getFullYear(), this.currentMonth.getMonth() + 1)
      .subscribe(
        (next) => {
          for (let index = 0; index < monthStart; index++) {
            this.daysMonth.push({ text: "", mants: [] });
          }

          for (let index = 1; index <= monthEnd2; index++) {
            const mants = next.days
              .filter((f) => f.Dia == index)
              .map((m) => {
                return {
                  Color: m.Color,
                  NoControl: m.NoControl,
                  Atrasado: m.Atrasado,
                  Realizado: m.Realizado,
                };
              })
              .sort((a, b) => a.NoControl.localeCompare(b.NoControl));

            this.daysMonth.push({
              text: index.toString().padStart(2, "0"),
              mants: [...mants],
            });
          }

          const missingDays = 7 - (this.daysMonth.length % 7);
          for (let index = 0; index < missingDays; index++) {
            this.daysMonth.push({ text: "", mants: [] });
          }

          this.campaings = next.campaigns;
        },
        (error) => {
          this.spinner.hide();
        },
        () => {
          setTimeout(() => {
            this.spinner.hide();
          }, 1000);
        }
      );
  }

  styleBadge(color) {
    const isDark = colorIsDarkSimple(color);
    return {
      color: isDark ? "#FFF" : "#000",
      "background-color": color,
    };
  }
}

function colorIsDarkSimple(bgColor) {
  const color = bgColor.charAt(0) === "#" ? bgColor.substring(1, 7) : bgColor;
  const r = parseInt(color.substring(0, 2), 16); // hexToR
  const g = parseInt(color.substring(2, 4), 16); // hexToG
  const b = parseInt(color.substring(4, 6), 16); // hexToB
  return r * 0.299 + g * 0.587 + b * 0.114 <= 186;
}
